import React from "react";
import {Box} from "@mui/material";
import PropTypes from "prop-types";


const TabPanel = ({children, value, index, ...props}) => {

    return <div role="tab-panel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tabpanel-${index}`}
        className="p-3"
        {...props}
    >
        {value === index && (
            <Box>
                {children}
            </Box>
        )}
    </div>
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
export default TabPanel
